import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const CourseCard = ({ course, index }) => (
  <Reveal delay={index * 0.12} className="h-full">
    <Link
      to={`/courses/${course.slug}`}
      data-testid={`course-card-${course.slug}`}
      className={`group relative flex flex-col h-full rounded-sm border p-8 lg:p-10 transition-all duration-500 hover:-translate-y-1.5 ${
        course.exclusive
          ? "bg-coal text-ivory border-coal hover:shadow-[0_24px_60px_-20px_rgba(16,17,15,0.5)]"
          : "bg-white border-line hover:border-ink/25 hover:shadow-[0_24px_60px_-24px_rgba(16,16,16,0.18)]"
      }`}
    >
      <span className={`absolute -top-2 right-6 text-[88px] leading-none font-semibold select-none pointer-events-none transition-transform duration-700 group-hover:-translate-y-1 ${
        course.exclusive ? "text-ivory/[0.05]" : "text-ink/[0.045]"
      }`} aria-hidden="true">{course.index}</span>
      <div className="flex items-center justify-between">
        <span className={course.exclusive ? "eyebrow-dark" : "eyebrow"}>{course.index} / {course.category}</span>
        {course.exclusive && (
          <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-pine-2 border border-pine-2/40 rounded-full px-3 py-1">Advanced</span>
        )}
      </div>
      <h3 className="mt-10 text-3xl lg:text-4xl tracking-tight">{course.title}</h3>
      <p className={`mt-4 text-base leading-relaxed ${course.exclusive ? "text-[#A0A09C]" : "text-dim"}`}>{course.description}</p>

      <div className={`mt-8 pt-6 border-t grid grid-cols-3 gap-4 ${course.exclusive ? "border-coalline" : "border-line"}`}>
        {[["Duration", course.duration], ["Mode", course.mode], ["Fee", course.fee]].map(([k, v]) => (
          <div key={k}>
            <p className={`font-mono text-[10px] uppercase tracking-[0.15em] ${course.exclusive ? "text-[#8E8E8B]" : "text-tertiary"}`}>{k}</p>
            <p className="mt-1.5 text-sm font-medium">{v}</p>
          </div>
        ))}
      </div>

      <div className="mt-8 flex flex-wrap gap-2">
        {course.topics.slice(0, 4).map((t) => (
          <span key={t} className={`text-xs rounded-full px-3 py-1.5 border ${course.exclusive ? "border-coalline text-[#A0A09C]" : "border-line text-dim"}`}>{t}</span>
        ))}
      </div>

      <span className={`link-arrow mt-auto pt-10 inline-flex items-center gap-2 text-sm font-medium ${course.exclusive ? "text-ivory" : "text-pine"}`}>
        Explore {course.title} <ArrowRight size={15} className="arrow" />
      </span>
    </Link>
  </Reveal>
);

export default CourseCard;
